import React, { useState, useEffect } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { db } from '../../../../firebase-config';
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Button, Card, message as antMessage } from 'antd';

const TermsEditor = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchTerms = async () => {
      setLoading(true);
      try {
        const docRef = doc(db, 'siteContent', 'terms');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setContent(docSnap.data().text);
        } else {
          setContent('');
        }
      } catch (error) {
        antMessage.error('Failed to load Terms and Conditions content.');
      }
      setLoading(false);
    };
    fetchTerms();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await setDoc(doc(db, 'siteContent', 'terms'), { text: content });
      antMessage.success('Terms and Conditions updated successfully!');
    } catch (error) {
      antMessage.error('Failed to save Terms and Conditions.');
    }
    setSaving(false);
  };

  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: 24 }}>
      <h1 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '24px' }}>Edit Terms and Conditions</h1>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Card title="Terms and Conditions Content">
          <p style={{ marginBottom: '16px', color: '#666' }}>
            Edit the terms and conditions content that will be displayed on the frontend.
          </p>
          <ReactQuill value={content} onChange={setContent} />
          <Button 
            type="primary" 
            onClick={handleSave} 
            loading={saving}
            style={{ marginTop: '16px' }}
          >
            {saving ? 'Saving...' : 'Save Terms and Conditions'}
          </Button>
        </Card>
      )}
    </div>
  );
};

export default TermsEditor; 